export default {
  'footer:link-section:customer-support-phone-number': '+41 44 505 11 60',
};
